<template>
    <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
        <div class="d-center-start room-picker">
            <el-select v-model="timeType" placeholder="日期模式" size="small" class="room-select" style="width: 120px;" @change="changeMode">
                <el-option v-for="item in selectMode" :key="item.value" :label="item.name" :value="item.value" />
            </el-select>
            <el-form-item  prop="select_time">
                <el-date-picker
                    v-model="ruleForm.select_time"
                    :type="timeType=='postTime'?'dates':'months'"
                    value-format="timestamp"
                    :picker-options="pickerOptions"
                    placeholder="选择日期">
                </el-date-picker>
            </el-form-item>
        </div>
        <!--用房需求-->
        <div class="mt-3 lislet">
            <div class=" mb-3 pl d-center-start moasr"  >
                <p class="righttext">单床房</p>
                <el-form-item  prop="s_num1">
                    <el-input type="number" v-model.number="ruleForm.s_num1" @mousewheel.native.prevent class="roomnumber" placeholder="间数">
                    <span slot="append">间</span>
                    </el-input>
                </el-form-item>
            </div>
            <div class=" mb-3 pl d-center-start moasr"  >
                <p class="righttext">双床房</p>
                <el-form-item  prop="s_num1">
                    <el-input type="number" v-model.number="ruleForm.s_num2" @mousewheel.native.prevent class="roomnumber" placeholder="间数">
                    <span slot="append">间</span>
                    </el-input>
                </el-form-item>
            </div>
        </div>
            <el-button type="primary" class="w-80 button" @click="submitForm('ruleForm')">确认修改</el-button>
            <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
        </el-form>
    </div>
</template>

<script>
import {mapGetters,mapActions,mapState} from 'vuex'

export default {
    name: 'AddRoom',
    props: {
      changetime: {},
      store_id:{}
    },
    data() {
        return {
            ruleForm: {
                select_time:[],
                s_num1:'',
                s_num2:'',
            },
            rules: {
                select_time: [
                    { required: true, message: '请选择日期时间', trigger: 'change' }
                ],
                s_num1: [
                    { required: true, message: '间数不能为空', trigger: 'change' }
                ],
            },
            //日历只能选当月和往后6个月的日期
            pickerOptions: {
                disabledDate: (time) => {
                    // 获取今天的日期（0点0分0秒）
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    // 计算6个月后的日期（今天 + 6个月）
                    const sixMonthsLater = new Date();
                    sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
                    sixMonthsLater.setHours(23, 59, 59, 999); // 精确到当天结束
                    return time < today || time > sixMonthsLater;
                }
            },
            priceArr: [
                { label: '单床房',type:1,price:'',num:0},
                { label: '双床房',type:2,price:'',num:0},
            ],
            selectMode:[{name:`按日期修改`,value:'postTime'},{name:`按月份修改`,value:'dealTime'},],
            timeType:'postTime',
        }
    },
    watch: {
        changetime: {
            handler(newVal, oldVal) {
                if(newVal.select_time){
                    this.ruleForm.select_time.push(newVal.select_time*1000);
                    this.ruleForm.s_num1=newVal.s_num1||0;
                    this.ruleForm.s_num2=newVal.s_num2||0;
                }
                console.log(newVal)
                // 处理逻辑...
            },
        immediate: true // 立即触发一次
        }
    },
    computed:{
        ...mapGetters(['isGroup'])
    },
    created() {
    },
    methods: {
        ...mapActions(['HotelsAddRoom']),
        //切换模式清空值
        changeMode(){
            this.ruleForm.select_time=''
        },
        //确认日期模式
        async changePicker(){
            let ruleForm={
                ...this.ruleForm
            },Monthtiem=[];
            //如果是月份则转换整月时间戳
            if(this.timeType=='dealTime'){
                for(let i in ruleForm.select_time){
                    let select_time=this.timeMonth(ruleForm.select_time[i]);
                    Monthtiem=Monthtiem.concat(select_time)
                }
                ruleForm.select_time=Monthtiem;
            }else{
                for(let i in ruleForm.select_time){
                    ruleForm.select_time[i]=ruleForm.select_time[i]/1000
                }
            }
            ruleForm.select_time=ruleForm.select_time.join(',');
            //提交表单
            this.HotelsAddRoom({
                data:{
                    ...ruleForm,
                    store_id:this.store_id
                },
                successFun:()=>{
                    console.log('提交成功')
                    this.$emit('switchsoto',(ruleForm))
                }
            });
        },
        /*验证表单*/
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.changePicker();
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        //循环当月每天0点时间戳
        timeMonth(roomType){
            console.log(roomType)
            //传月份时间戳判断当月有多少天
            let date = new Date(roomType);
            const year = date.getFullYear();
            const month = date.getMonth();
            let n= new Date(year, month + 1, 0).getDate(),Monthtiem=[];
            //获取当天时间戳
            const currentDate = new Date();
            // 设置时间为00:00:00
            currentDate.setHours(0, 0, 0, 0);
            // 获取时间戳（毫秒）
            let qs=currentDate.getTime();
            //循环当月每天0点时间戳生成月份日期
            for(let i=1;i<=n;i++){
                let time=new Date(year, month, i, 0, 0, 0, 0)   ;
                //判断是否大于当前时间戳
                if(qs<=time){
                    Monthtiem.push(time/1000)
                }
            }
            return Monthtiem;
        },
    },
}
</script>
<style lang="scss" scoped>
  .righttext{
    text-align: right;
    min-width: 50px;
    margin-right: 10px;
    margin-top: -20px;
  }
  .roomPrice{
    width: 140px;
    text-align: center;
  }
  .roomnumber{
    width: 100px;
  }
  .lislet{
    width: 98%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    justify-content: space-between;   
  }
  .room-picker{
    margin: 0 auto;
    margin-left: 14px;
  }
  .button{
    margin: 20px  auto 0 auto;
    display: block;
    width: 92% !important;
  }
  .moasr{
    margin: 0 auto;
  }
</style>
<style>
    .roomPrice .el-input__inner,.roomnumber .el-input__inner{
        text-align: center;
        padding: 0 6px;
    }
    .room-picker .el-date-editor{
        width:260px;
    }
    .room-picker .el-input--prefix .el-input__inner{
        border-radius: 0 4px 4px 0;
        margin-left: -1px;
    }
    .room-select,.room-picker .el-input--small .el-input__inner{
        height: 40px;
        line-height: 40px;
        
    }
    .el-input--small .el-input__inner{
        border-radius: 4px 0 0 4px;
    }
    .room-select{
 
        margin-top: -22px;
    }
</style>
